export default __webpack_public_path__ + "static/media/queston-mark-sc.9d49f385.svg";